import React from "react";
import SEO from "../components/SEO";
const Privacy = () => (
  <>
    <SEO title="Privacy Policy" />
    <section className="max-w-3xl mx-auto px-6 py-16 text-white/80 leading-relaxed">
      <p className="font-mono-cap text-[10px] text-white/40">Legal</p>
      <h1 className="font-serif text-5xl mt-2 text-white">Privacy Policy.</h1>
      <div className="mt-8 space-y-5 text-sm">
        <p>This policy is compliant with the Information Technology Act, 2000 and applicable rules of India.</p>
        <p><b className="text-white">Data we collect:</b> name, delivery address, city, pincode, phone number, email, order details. We do not store any payment instrument data — UPI payments happen entirely inside your UPI app.</p>
        <p><b className="text-white">How we use it:</b> only to fulfil your order, provide tracking, and (with your consent) send drop announcements via newsletter.</p>
        <p><b className="text-white">How we store it:</b> securely on our managed servers and database, accessed only by authorised team members.</p>
        <p><b className="text-white">Sharing:</b> we share only what's required with our courier partner to deliver your order.</p>
        <p><b className="text-white">Your rights:</b> request access, correction, or deletion of your data anytime by emailing thedripchexk@gmail.com.</p>
        <p><b className="text-white">Cookies:</b> we use minimal cookies to keep your cart and remember consent. See the cookie banner.</p>
      </div>
    </section>
  </>
);
export default Privacy;
